export default __webpack_public_path__ + "94dffd52cd3125a64587f9b72f5f5a59.svg";